function e(e,r){return e.reduce((e,t)=>({...e,[t[r]]:(e[t[r]]??0)+1}),{})}export{e as default};
